import { createAction } from 'redux-actions';
import { FIRST_VS_LATEST } from './student-constants';

export const CLEAR_SELECTED_IMPROVEMENTS = 'CLEAR_SELECTED_IMPROVEMENTS';
export const SET_DEFAULT_SELECTED_IMPROVEMENTS =
    'SET_DEFAULT_SELECTED_IMPROVEMENTS';
export const UPDATE_SELECTED_IMPROVEMENT = 'UPDATE_SELECTED_IMPROVEMENT';

const clearSelectedImprovements = createAction(CLEAR_SELECTED_IMPROVEMENTS);
const updateSelectedImprovement = createAction(UPDATE_SELECTED_IMPROVEMENT);

function setDefaultSelectedImprovements(topics) {
    const selectedImprovements = {};
    topics.forEach((topic) => {
        selectedImprovements[topic.id] = FIRST_VS_LATEST;
    });

    return {
        type: SET_DEFAULT_SELECTED_IMPROVEMENTS,
        payload: selectedImprovements
    };
}

export default {
    clearSelectedImprovements,
    updateSelectedImprovement,
    setDefaultSelectedImprovements
};



// WEBPACK FOOTER //
// ./containers/participation/student/selected-improvements-actions.js